var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9597 21.3333H24.0397C22.3463 21.3333 21.333 22.3466 21.333 24.0399V27.9599C21.333 29.6533 22.3463 30.6666 24.0397 30.6666H27.9597C29.653 30.6666 30.6663 29.6533 30.6663 27.9599V24.0399C30.6663 22.3466 29.653 21.3333 27.9597 21.3333ZM28.8397 24.5999L25.6797 28.2933C25.5597 28.4399 25.373 28.5333 25.1863 28.5333C25.173 28.5333 25.173 28.5333 25.1597 28.5333C24.973 28.5333 24.7997 28.4666 24.6663 28.3333L23.213 26.8933C22.9463 26.6266 22.9463 26.1866 23.213 25.9199C23.4797 25.6533 23.9197 25.6399 24.1863 25.9199L25.1197 26.8399L27.7863 23.7199C28.0397 23.4266 28.4663 23.3999 28.7597 23.6399C29.053 23.8799 29.0797 24.3199 28.8397 24.5999Z",
    fill: "#66B929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.3337 27.9601V24.0401C21.3337 22.3467 22.347 21.3334 24.0403 21.3334H27.9603C28.4937 21.3334 28.947 21.4401 29.3337 21.6267C29.3337 21.6134 29.3337 21.6001 29.3337 21.5734V10.4134C29.3337 5.56008 26.4403 2.66675 21.587 2.66675H10.4137C5.56033 2.66675 2.66699 5.56008 2.66699 10.4134V21.5734C2.66699 26.4401 5.56033 29.3334 10.4137 29.3334H21.5737C21.587 29.3334 21.6003 29.3334 21.627 29.3334C21.4403 28.9467 21.3337 28.4934 21.3337 27.9601Z",
    fill: "#66B929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 22C8.78634 22 8.33301 21.5467 8.33301 21V17C8.33301 16.4533 8.78634 16 9.33301 16C9.87967 16 10.333 16.4533 10.333 17V21C10.333 21.5467 9.87967 22 9.33301 22Z",
    fill: "#66B929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22C15.4533 22 15 21.32 15 20.5V14.5C15 13.68 15.4533 13 16 13C16.5467 13 17 13.68 17 14.5V20.5C17 21.32 16.5467 22 16 22Z",
    fill: "#66B929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22C22.4533 22 22 21.0933 22 20V12C22 10.9067 22.4533 10 23 10C23.5467 10 24 10.9067 24 12V20C24 21.0933 23.5467 22 23 22Z",
    fill: "#66B929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffective);
export default __webpack_public_path__ + "static/media/effective.336cd410d135dc35e42183ef1b95b286.svg";
export { ForwardRef as ReactComponent };